import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";

const renderIntermediateItem = (item) => {
  if (item.label === "Members") {
    return (
      <Box
        component="span"
        sx={{ fontSize: "18px", fontWeight: 600, color: "#080A0E" }}
      >
        {item.label}
      </Box>
    );
  }

  if (item.onClick) {
    return (
      <Box
        component="span"
        onClick={item.onClick}
        sx={{
          fontSize: "18px",
          fontWeight: 600,
          color: "#080A0E",
          cursor: "pointer",
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline",
            textUnderlineOffset: "3px",
          },
        }}
      >
        {item.label}
      </Box>
    );
  }

  return (
    <Link
      to={item.path}
      sx={{
        fontSize: "18px",
        fontWeight: 600,
        color: "#080A0E",
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline",
          textUnderlineOffset: "3px",
        },
      }}
    >
      {item.label}
    </Link>
  );
};

const Breadcrumb = ({ items }) => {
  return (
    <Box
      sx={{
        mb: 1,
        ml: -2.5,
        mr: 0,
        pl: 3,
        pr: 0,
        pt: 1,
        "& a, & .breadcrumb-current": {
          color: "#080A0E",
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "30px",
          letterSpacing: "0%",
          textDecoration: "none",
          fontStyle: "bold",
          "&:hover": {
            textDecoration: "underline",
          },
        },
        "& .breadcrumb-separator": {
          margin: "0 8px",
          color: "#080A0E",
          fontWeight: 700,
          fontSize: "20px",
          lineHeight: "30px",
        },
        "& .breadcrumb-item": {
          display: "inline-flex",
          alignItems: "center",
          whiteSpace: "nowrap",
          lineHeight: 1,
          flexShrink: 0,
        },
        "& .breadcrumb-item:last-child": {
          flex: "1 1 auto",
          minWidth: 0,
          overflow: "hidden",
        },
        "& .breadcrumb-current": {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
          display: "inline-block",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap",
          minWidth: 0,
          width: "100%",
        }}
      >
        {items.map((item, index) => (
          <Box
            key={`breadcrumb-${item.label || ""}-${item.path || ""}-${index}`}
            className="breadcrumb-item"
          >
            {index < items.length - 1 ? (
              <>
                {renderIntermediateItem(item)}
                <span className="breadcrumb-separator"> &gt; </span>
              </>
            ) : (
              <Box
                component="span"
                className="breadcrumb-current"
                title={typeof item.label === "string" ? item.label : undefined}
                sx={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#080A0E",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  display: "inline-block",
                  cursor: "default",
                  "&:hover": {
                    textDecoration: "none",
                  },
                }}
              >
                {item.label}
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Breadcrumb;

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      path: PropTypes.string,
    }),
  ).isRequired,
};
